/* ==========================================================================
   EOS YMM — keep the shopper's vehicle attached to the collection facets.

   Shopify renders at most 200 values for a metafield storefront filter. The
   catalogue has far more fitment keys than that, so a shopper's vehicle is
   often NOT among the checkboxes the theme submits. Ticking any other facet
   (product type, availability, price) rebuilt the URL from the form alone and
   silently dropped the vehicle — "rear spoilers for my Lexus IS" turned into
   "every rear spoiler in the catalogue".

   Fix: mirror whatever vehicle keys are already in the URL into every filter
   form as hidden inputs, so the theme carries them through each facet change.
   Only the URL is trusted — this never applies a filter on its own.
   ========================================================================== */
(function () {
  'use strict';

  var PARAM = 'filter.p.m.eos.fitment_keys';
  var KEEP = 'data-eos-keep';

  function urlValues() {
    try {
      return new URLSearchParams(window.location.search).getAll(PARAM);
    } catch (e) {
      return [];
    }
  }

  function inputsIn(form) {
    return Array.prototype.slice.call(form.querySelectorAll('input[name="' + PARAM + '"]'));
  }

  /** Does this form already carry exactly the vehicle keys the URL asks for? */
  function inSync(form, values) {
    var carried = {};
    var mirrored = [];
    inputsIn(form).forEach(function (el) {
      if (el.hasAttribute(KEEP)) mirrored.push(el.value);
      if (el.hasAttribute(KEEP) || el.checked) carried[el.value] = true;
    });
    for (var i = 0; i < values.length; i++) {
      if (!carried[values[i]]) return false;
    }
    // a stale mirror from a previous URL must be cleared out
    for (var j = 0; j < mirrored.length; j++) {
      if (values.indexOf(mirrored[j]) === -1) return false;
    }
    return true;
  }

  function syncForm(form, values) {
    inputsIn(form).forEach(function (el) {
      if (el.hasAttribute(KEEP)) el.parentNode.removeChild(el);
    });
    values.forEach(function (value) {
      var real = inputsIn(form).filter(function (el) { return el.value === value; });
      if (real.length) {
        // Shopify did render this one — let the theme's own checkbox carry it
        real.forEach(function (el) { el.checked = true; });
        return;
      }
      var hidden = document.createElement('input');
      hidden.type = 'hidden';
      hidden.name = PARAM;
      hidden.value = value;
      hidden.setAttribute(KEEP, '1');
      form.appendChild(hidden);
    });
  }

  /** Idempotent: touches the DOM only when a form is actually out of sync, so
      the MutationObserver below cannot retrigger itself in a loop. */
  function sync() {
    var values = urlValues();
    if (!values.length) return;
    var forms = document.querySelectorAll('form.filter-form');
    for (var i = 0; i < forms.length; i++) {
      if (!inSync(forms[i], values)) syncForm(forms[i], values);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', sync);
  } else {
    sync();
  }

  // the facet panel is re-rendered over AJAX after every filter change
  if (window.MutationObserver) {
    var scheduled = null;
    var root = document.querySelector('main') || document.body;
    if (root) {
      new MutationObserver(function () {
        if (scheduled) return;
        scheduled = window.setTimeout(function () { scheduled = null; sync(); }, 120);
      }).observe(root, { childList: true, subtree: true });
    }
  }

  window.addEventListener('popstate', sync);
  document.addEventListener('shopify:section:load', sync);
})();
